export default {
  title: 'Månedlige opgørelser',
  list: {
    empty_list: {
      title: 'Ingen månedlige opgørelser endnu.',
    },
    fields: {
      month: 'Måned',
      stripe_service_invoice_url: 'Stripe-faktura',
      paypal_service_invoice_url: 'PayPal-faktura',
    },
    button: {
      title: 'Eksportér',
    },
  },
  export_modal: {
    title: 'Eksportér',
    start_date: {
      title: 'Startdato',
      placeholder: 'dato',
    },
    end_date: {
      title: 'Slutdato',
      placeholder: 'dato',
    },
    button: {
      export: 'Eksportér',
      close: 'Luk',
    },
  },
  toasts: {
    failed_to_load_data: 'Data kunne ikke indlæses',
  },
};
